import { ReactElement, useEffect } from 'react';
import { useUnleashBoolean } from 'react-scale/components/featureFlag/useUnleashFeatureFlag';
import { OPS_HUB_FRONTEND_URL } from 'react-scale/lib/constants';

type Props = {
  children: ReactElement;
};

export default function MaybeRedirectToVite({ children }: Props) {
  const doRedirect =
    useUnleashBoolean('redirect-to-opshub-on-vite', {}, { defaultValue: false }) &&
    OPS_HUB_FRONTEND_URL &&
    !process.env.IS_VITE;

  useEffect(() => {
    if (doRedirect) {
      const targetUrl = `${OPS_HUB_FRONTEND_URL}${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.location.replace(targetUrl);
    }
  }, [doRedirect]);

  if (doRedirect) return <div>Redirecting to vite...</div>;
  return children;
}
